import { AxiosInstance } from 'axios';
import { ArgumentValidator } from '../../helpers';
import { QueryStringBuilder } from '../helpers/query-string-builder';
import { IActivityInitialState } from '../models/activity-event/activity-initial-state';
import { IActivityState } from '../models/activity-event/activity-state';
import { IPublishActivityEvent } from '../models/activity-event/publish-activity-event';

export class ActivityEventClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/activity/event`;
    }

    public async getState(id: string): Promise<IActivityInitialState> {

        ArgumentValidator.notNullOrEmpty(id, `id`);

        const response = await this.axiosClient.get(
            `${this.apiUrl}/${id}/state`
        );

        return response.data;
    }

    public async publish(id: string, publishEvent: IPublishActivityEvent): Promise<IActivityState> {

        ArgumentValidator.notNullOrEmpty(id, `id`);
        ArgumentValidator.notNullOrEmpty(publishEvent, `publishEvent`);

        try {

            const url = new QueryStringBuilder()
                .build(`${this.apiUrl}/${id}/publish`);

            const response = await this.axiosClient.post(url, publishEvent);

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }
}
